'use client';

import { useEffect } from 'react';

export default function MarketingScripts({ campaign }: { campaign: CampaignType }) {
  useEffect(() => {
    import('@/lib/marketing/index').then((Scripts) => {
      Scripts.run(campaign);
    });
  }, [campaign]);

  return <></>;
}

export type CampaignType = {
  campaign: { id: number };
  offer: { id: number };
  lead_type: { id: number; name: string };
  lead_score_baseline: number;
  internal_lead_type_id: number;
  lead_source: { id: number; name: string; type: { id: number; name: string } };
};
